import {
  Button, Divider, FormGroup, Menu,
  Paper, Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import {
  useAddress
} from "components/ltr-request-document/components/Address";
import {
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import {
  defaultJobWorkpermitTable,
  getDefaultRow,
  getErrorMessage,
  isError,
  mapJobWorkpermitTable,
  personalFieldResolver
} from "libs/utils/form";
import { get } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { addPersonal } from "redux/modules/addPersonalSlice";
import { canEditForm } from "redux/modules/authSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";

import { CloudDownload, CloudUpload } from "@material-ui/icons";
import { DatePicker } from "@material-ui/pickers";
import CompanyInfoSection from "components/ltr-request-document/components/CompanyInfoSection";
import JobSection from "components/ltr-request-document/components/JobSection";
import UploadDucument from "components/ltr-request-document/components/UploadDucument";
import { useFormik } from "formik";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import HttpClient from "libs/utils/HttpClient";
import mime from "mime";
import moment from "moment";
import { useParams } from "react-router-dom";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import {
  getDocumentRequiredPreApprove,
  getSmartForm,
  getSmartFormFieldConfig,
  selectCurrentSmartServiceIdType,
  selectSmartFormFieldConfig
} from "redux/modules/visaForm";
import AllDocumentsService from "services/AllDocumentsService";
import FileService from "services/FileService";
import * as yup from "yup";

import PassportSection from "components/home/components/PreApproved/PassportSection";
import PersonalInfoSection from "components/home/components/PreApproved/PersonalInfoSection";
import TravelInfo from "components/home/components/PreApproved/TravelInfo";
import WorkPermit from "components/home/components/PreApproved/WorkPermit";
import VisaIssuanceSection from "components/ltr-request-document/components/VisaIssuanceSection";
import { RoleId } from "libs/configs/constant";

export default function PreApprovedAdmin({ colSpan = 6 }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const masterData = useSelector(selectMasterData);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const params = useParams();
  const [dataDetail, setDataDetail] = useState([]);
  const draftId = get(params, "draftId", "") || "";
  // const { smartserviceId } = useSmartService();
  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceIdType);
  const personalId = get(personalDetail, "personalID", "");
  const profile = useSelector((state) => state.user.profile);
  const history = useHistory();

  const [anchorElPrint, setAnchorElPrint] = React.useState(null);
  const openPrint = Boolean(anchorElPrint);

  const [anchorElDownloadDoc, setAnchorElDownloadDoc] = React.useState(null);
  const openDownloadDocMenu = Boolean(anchorElDownloadDoc);

  const [anchorElUploadDoc, setAnchorElUploadDoc] = React.useState(null);
  const openUploadDocMenu = Boolean(anchorElUploadDoc);

  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();
  const [listPreapprove, setListpreaprove] = useState([]);
  const accommodationConfig = get(masterData, "accommodationConfig", []);
  const canEdit = useSelector(canEditForm);

  const [responsesw, setResponsesw] = useState([]);
  const [error_msg, setErrorMsg] = useState("");

  const uploadFileInputRef = useRef()
  const [downloadDocumentList, setDownloadDocumentList] = useState([])
  const [selectedUploadDocId, setSelectedUploadDocId] = useState(null)
  const [disabled, setDisabled] = useState({
    PersonalInformation: true,
    VisaIssuance: true,
    AddressInThailand: true,
    Passport: true,
    LatestTravelnformation: true,
    DigitalWorkPermit: true,
    CompanyInformation: true,
    JobInformation: true,
  })

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const smartformDetail = get(dataDetail, "detail", []).reduce(
    smartNameById,
    {}
  );
  const ConditionType = get(smartformDetail, "ConditionType.value", "");
  const isGovernment = !(
    ConditionType === "Start up" || ConditionType === "Company"
  );
  const buttonRef = useRef();
  const handleClickPrint = (event) => {
    setAnchorElPrint(event.currentTarget);
  };
  const handleClosePrint = () => {
    setAnchorElPrint(null);
  };

  const getListpreapprove = async (draftId) => {
    const res = await HttpClient.get(
      `/api/stampfrom/preapprove/list?draftId=${draftId}`
    );
    // console.log(res);
    setListpreaprove(res);
  };

  useEffect(() => {
    dataDetail?.visaissuance?.overseas ? fetchStamp("S11") : fetchStamp("S1");
    if (dataDetail?.statusProcessId === "RPA") {
      getListpreapprove(dataDetail?.draftId);
    }
  }, [dataDetail]);

  const getDownloadDocumentList = async (draftId) => {
    const res = await HttpClient.get(
      `/api/stampfrom/docdownload/list?draftId=${draftId}`
    );
    setDownloadDocumentList(res.results ?? []);
  };

  useEffect(() => {
    if (dataDetail?.draftId) {
      getDownloadDocumentList(dataDetail?.draftId);
    }
  }, [dataDetail?.draftId]);


  useEffect(() => {
    if (smartServiceId) {
      dispatch(
        getSmartFormFieldConfig({
          smartserviceId: smartServiceId,
          smartserviceGroupID: "LTR",
        })
      );
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
          smartserviceGroupID: "LTR",
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);
  useEffect(async () => {
    dispatch(
      getMasterData({
        nationalityConfig: true,
        CountryConfig: true,
        visaTypeConfig: true,
        immPointConfig: true,
        vehicleConfig: true,
        countryEmbassy: true,
        CityConfig: true,
        VisaTypeConfig: true,
        theImmigrationBureauConfig: true,
        JobPositionConfig: true,
        accommodationConfig: true,
        titleConfig: true,
        enterprisesConfig: true,
        companyTypeConfig: true,
      })
    );
    // const res2 = await dispatch(getAllDocumentsList({ draftId: draftId }));
    const res3 = await dispatch(getSmartForm({ draftId: draftId }));
    dispatch(
      getDocumentRequiredPreApprove({
        draftId,
      })
    );
    // console.log(res3.payload);
    // console.log(res2?.payload[0]);
    setDataDetail(res3?.payload);
  }, [dispatch]);

  useEffect(() => {
    // TODO uncomment for check disabled group
    // const checkDisabledGroup = async () => {
    //   const response = await HttpClient.post(
    //     `/api/visaform/smartfrom/checkxxxxxxxx`,
    //   );
    // }

    // setDisabled(response.results)
    // checkDisabledGroup()

    // TODO remove after integrate api check should disabled group
    setDisabled({
      PersonalInformation: false,
      VisaIssuance: false,
      AddressInThailand: false,
      Passport: false,
      LatestTravelnformation: false,
      DigitalWorkPermit: false,
      CompanyInformation: false,
      JobInformation: false,
    })

  }, [])


  const detailList = [
    "WPCompanyRegisterNumber",
    "WPCompanyName",
    "WPCompanyAddress",
    "WPCompanyOfficeNumber",
    "WPCompanyWebsite",
    "WPCompanyProductsServices",
    "WPContractTermType",
    "WPContactPersonInThai",
    "WPContactRelationship",
    "WPContactEmail",
    "WPContactMobile",
    "WPContractYear",
    "WPContractMonth",
    "WPContractOther",
    "WPContractPeriodFrom",
    "WPContractPeriodTo",
    "JobPositionWorkPermit",
    "DesiredWorkingPeriodID",
    "DesiredWorkingPeriodYear",
    "DesiredWorkingPeriodMonth",
    "PeriodStart",
    "PeriodEnd",
    "companyType",
    "emp_idcard_no",
    "emp_fullname",
    "emp_address",
    "emp_province_ddl",
    "emp_district_ddl",
    "emp_subdistrict_ddl",
    "emp_tel",
  ];

  const detail = get(dataDetail, "detail", [])
    .filter((field) => detailList.includes(field.smartName))
    .reduce(smartNameById, {});

  const formik = useFormik({
    enableReinitialize: true,
    // validationSchema,
    initialValues: {
      personal: {
        titleID: dataDetail?.personal?.titleID
          ? dataDetail?.personal?.titleID
          : null,
        gender: dataDetail?.personal?.gender
          ? dataDetail?.personal?.gender
          : null,

        personalID: dataDetail?.personal?.personalID
          ? dataDetail?.personal?.personalID
          : null,
        fistName: dataDetail?.personal?.firstname
          ? dataDetail?.personal?.firstname
          : "",
        middleName: dataDetail?.personal?.middleName
          ? dataDetail?.personal?.middleName
          : "",
        lastName: dataDetail?.personal?.lastName
          ? dataDetail?.personal?.lastName
          : "",
        nationalityID: dataDetail?.personal?.nationalityID
          ? dataDetail?.personal?.nationalityID
          : null,
        birthDate: dataDetail?.personal?.birthDate
          ? dataDetail?.personal?.birthDate
          : "",
        email: dataDetail?.personal?.email ? dataDetail?.personal?.email : "",
        mobile: dataDetail?.personal?.mobile
          ? dataDetail?.personal?.mobile
          : "",
        placeOfBirth: dataDetail?.personal?.placeOfBirth
          ? dataDetail?.personal?.placeOfBirth
          : "",

        passportNumber: dataDetail?.personal?.passportNumber
          ? dataDetail?.personal?.passportNumber
          : "",
        issuedAt: dataDetail?.personal?.issuedAt
          ? dataDetail?.personal?.issuedAt
          : "",
        soi: dataDetail?.personal?.soi ? dataDetail?.personal?.soi : "",
        road: dataDetail?.personal?.road ? dataDetail?.personal?.road : "",
        dateofIssue: dataDetail?.personal?.dateofIssue
          ? dataDetail?.personal?.dateofIssue
          : "",
        validuntil: dataDetail?.personal?.validuntil
          ? dataDetail?.personal?.validuntil
          : "",
        visatypeID: null,
        titleOther: dataDetail?.personal?.titleOther
          ? dataDetail?.personal?.titleOther
          : "",
        MaritalID: dataDetail?.personal?.maritalID
          ? dataDetail?.personal?.maritalID
          : null,
        MaritalOther: dataDetail?.personal?.MaritalOther
          ? dataDetail?.personal?.MaritalOther
          : "",
        addressInHomeCountry: dataDetail?.personal?.addressInHomeCountry
          ? dataDetail?.personal?.addressInHomeCountry
          : "",
        addressInThailand: dataDetail?.personal?.addressInThailand
          ? dataDetail?.personal?.addressInThailand
          : "",
        // ProvinceId: get(personal, "ProvinceId", ""),
        // SubDistrictId: get(personal, "SubDistrictId", ""),
        // DistrictId: get(personal, "DistrictId", ""),
        identificationNumber: dataDetail?.personal?.identificationNumber
          ? dataDetail?.personal?.identificationNumber
          : "",
        accommodationID: dataDetail?.personal?.accommodationID
          ? dataDetail?.personal?.accommodationID
          : null,
        houseNumber: dataDetail?.personal?.houseNumber
          ? dataDetail?.personal?.houseNumber
          : "",
      },
      startDate: dataDetail?.workpermit?.startDate
        ? dataDetail?.workpermit?.startDate
        : null,
      endDate: dataDetail?.workpermit?.endDate
        ? dataDetail?.workpermit?.endDate
        : null,
      visaissuance: {
        visaInssuanceId: dataDetail?.visaissuance?.visaInssuanceId
          ? dataDetail?.visaissuance?.visaInssuanceId
          : null,
        overseas:
          dataDetail?.visaissuance?.overseas !== null
            ? dataDetail?.visaissuance?.overseas
            : true,
        countryId: dataDetail?.visaissuance?.countryId
          ? dataDetail?.visaissuance?.countryId
          : "",
        cityId: dataDetail?.visaissuance?.cityId
          ? dataDetail?.visaissuance?.cityId
          : "",
        thailand: dataDetail?.visaissuance?.thailand
          ? dataDetail?.visaissuance?.thailand
          : false,
        theImmigrationBureauID: dataDetail?.visaissuance?.theImmigrationBureauID
          ? dataDetail?.visaissuance?.theImmigrationBureauID
          : null,
        visaTypeId: dataDetail?.visaissuance?.visaTypeId
          ? dataDetail?.visaissuance?.visaTypeId
          : "",
        visaExp: dataDetail?.visaissuance?.visaExp
          ? dataDetail?.visaissuance?.visaExp
          : "",
      },
      // visatypeId: dataDetail?.workpermit?.visatypeId
      //   ? dataDetail?.workpermit?.visatypeId
      //   : "",
      // visaNo: dataDetail?.workpermit?.visaNo
      //   ? dataDetail?.workpermit?.visaNo
      //   : "",
      // visaIssue: dataDetail?.workpermit?.visaIssue
      //   ? dataDetail?.workpermit?.visaIssue
      //   : "",
      // immPointID: dataDetail?.workpermit?.immPointID
      //   ? dataDetail?.workpermit?.immPointID
      //   : "",
      // immNo: dataDetail?.workpermit?.immNo ? dataDetail?.workpermit?.immNo : "",
      // fromCountryID: dataDetail?.workpermit?.fromCountryID
      //   ? dataDetail?.workpermit?.fromCountryID
      //   : "",
      // vehicleID: dataDetail?.workpermit?.vehicleID
      //   ? dataDetail?.workpermit?.vehicleID
      //   : "",
      // thaiLastDate: dataDetail?.workpermit?.thaiLastDate
      //   ? dataDetail?.workpermit?.thaiLastDate
      //   : "",
      // stampEXP: dataDetail?.workpermit?.stampEXP
      //   ? dataDetail?.workpermit?.stampEXP
      //   : "",
      workpermit: {
        accommodationID: dataDetail?.workpermit?.accommodationID
          ? dataDetail?.workpermit?.accommodationID
          : null,
        houseNumber: dataDetail?.workpermit?.houseNumber
          ? dataDetail?.workpermit?.houseNumber
          : "",
        soi: dataDetail?.workpermit?.soi ? dataDetail?.workpermit?.soi : "",
        road: dataDetail?.workpermit?.road ? dataDetail?.workpermit?.road : "",
        addressInThailand: dataDetail?.workpermit?.addressInThailand
          ? dataDetail?.workpermit?.addressInThailand
          : "",
        ProvinceId: dataDetail?.workpermit?.provinceId
          ? dataDetail?.workpermit?.provinceId
          : "",
        DistrictId: dataDetail?.workpermit?.districtId
          ? dataDetail?.workpermit?.districtId
          : "",
        SubDistrictId: dataDetail?.workpermit?.subDistrictId
          ? dataDetail?.workpermit?.subDistrictId
          : "",
        Zipcode: dataDetail?.workpermit?.zipcode
          ? dataDetail?.workpermit?.zipcode
          : "",
        isRequest: dataDetail?.workpermit?.isRequest
          ? dataDetail?.workpermit?.isRequest
          : false,
        // --
        workPermitNo: dataDetail?.workpermit?.workPermitNo
          ? dataDetail?.workpermit?.workPermitNo
          : "",
        // -----
        visatypeId: dataDetail?.workpermit?.visatypeId
          ? dataDetail?.workpermit?.visatypeId
          : "",
        visaNo: dataDetail?.workpermit?.visaNo
          ? dataDetail?.workpermit?.visaNo
          : "",
        visaIssue: dataDetail?.workpermit?.visaIssue
          ? dataDetail?.workpermit?.visaIssue
          : "",
        immPointID: dataDetail?.workpermit?.immPointID
          ? dataDetail?.workpermit?.immPointID
          : "",
        immNo: dataDetail?.workpermit?.immNo ? dataDetail?.workpermit?.immNo : "",
        fromCountryID: dataDetail?.workpermit?.fromCountryID
          ? dataDetail?.workpermit?.fromCountryID
          : "",
        vehicleID: dataDetail?.workpermit?.vehicleID
          ? dataDetail?.workpermit?.vehicleID
          : "",
        thaiLastDate: dataDetail?.workpermit?.thaiLastDate
          ? dataDetail?.workpermit?.thaiLastDate
          : "",
        stampEXP: dataDetail?.workpermit?.stampEXP
          ? dataDetail?.workpermit?.stampEXP
          : "",
      },
      document: {
        companyType: get(detail, "companyType.value", "C"),
        emp_idcard_no: get(detail, "emp_idcard_no.value", ""),
        emp_fullname: get(detail, "emp_fullname.value", ""),
        emp_address: get(detail, "emp_address.value", ""),
        emp_province_ddl: get(detail, "emp_province_ddl.value", ""),
        emp_district_ddl: get(detail, "emp_district_ddl.value", ""),
        emp_subdistrict_ddl: get(detail, "emp_subdistrict_ddl.value", ""),
        emp_tel: get(detail, "emp_tel.value", ""),

        WPCompanyRegisterNumber: get(
          detail,
          "WPCompanyRegisterNumber.value",
          ""
        ),
        WPCompanyName: get(detail, "WPCompanyName.value", ""),
        WPCompanyAddress: get(detail, "WPCompanyAddress.value", ""),
        WPCompanyOfficeNumber: get(detail, "WPCompanyOfficeNumber.value", ""),
        WPCompanyWebsite: get(detail, "WPCompanyWebsite.value", ""),
        WPCompanyProductsServices: get(
          detail,
          "WPCompanyProductsServices.value",
          ""
        ),
        WPContractTermType: get(detail, "WPContractTermType.value", ""),
        WPContactPersonInThai: get(detail, "WPContactPersonInThai.value", ""),
        WPContactRelationship: get(detail, "WPContactRelationship.value", ""),
        WPContactEmail: get(detail, "WPContactEmail.value", ""),
        WPContactMobile: get(detail, "WPContactMobile.value", ""),
        WPContractYear: get(detail, "WPContractYear.value", ""),
        WPContractMonth: get(detail, "WPContractMonth.value", ""),
        WPContractOther: get(detail, "WPContractOther.value", ""),
        WPContractPeriodFrom: get(detail, "WPContractPeriodFrom.value", ""),
        WPContractPeriodTo: get(detail, "WPContractPeriodTo.value", ""),
        JobPositionWorkPermit: getDefaultRow(
          detail,
          "JobPositionWorkPermit.value",
          defaultJobWorkpermitTable
        ).map(mapJobWorkpermitTable),
      },
      //   overseas: isOversea,
      //   thailand: !isOversea,
      //   theImmigrationBureauID:
      //     docDetail?.visaissurance?.theImmigrationBureauID || "",
      //   countryId: docDetail?.visaissurance?.countryId,
      //   cityId: docDetail?.visaissurance?.cityId,
    },
    onSubmit: async (values) => {
      showAdminLoading();
      const params = {
        startDate: values.startDate,
        endDate: values.endDate,
        draftId: draftId,
      };
      try {
        const response = await HttpClient.post(
          `/api/stampfrom/approve`,
          params
        );
        if (response.status) {
          hideAdminLoading();
          alert("Success");
          history.push(`/admin/smart-visa/preapprovelist`);
          return response;
        } else {
          hideAdminLoading();
          setErrorMsg(response?.message);
          alert(response?.message);
        }
        return Promise.reject(response);
      } catch (error) {
        const newError = error;
        throw newError;
      }
    },
  });

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const addressFieldOptions = useAddress({
    formik,
    ProvinceFieldName: "workpermit.ProvinceId",
    DistrictFieldName: "workpermit.DistrictId",
    SubDistrictFieldName: "workpermit.SubDistrictId",
    ZipcodeFieldName: "workpermit.Zipcode",
  });

  const validationSchema = yup.object({
    visaNo: yup.string().when("visaissuance.thailand", {
      is: (thailand) => thailand,
      then: yup.string().required("Visa Number. is required."),
      otherwise: yup.string(),
    }),
    visatypeId: yup.string().when("visaissuance.thailand", {
      is: (thailand) => thailand,
      then: yup.string().required("Type of visa you are holding is required."),
      otherwise: yup.string(),
    }),
    visaIssue: yup.string().when("visaissuance.thailand", {
      is: (thailand) => thailand,
      then: yup
        .string()
        .required("Place of visa issuance/ issued at is required."),
      otherwise: yup.string(),
    }),
    immPointID: yup.string().when("visaissuance.thailand", {
      is: (thailand) => thailand,
      then: yup.string().required("Port of entry is required."),
      otherwise: yup.string(),
    }),
    immNo: yup.string().when("visaissuance.thailand", {
      is: (thailand) => thailand,
      then: yup.string().required("TM 6. is required."),
      otherwise: yup.string(),
    }),
    fromCountryID: yup.string().when("visaissuance.thailand", {
      is: (thailand) => thailand,
      then: yup.string().required("Travel from (country)  is required."),
      otherwise: yup.string(),
    }),
    vehicleID: yup.string().when("visaissuance.thailand", {
      is: (thailand) => thailand,
      then: yup.string().required("Mean of transport  is required."),
      otherwise: yup.string(),
    }),
    thaiLastDate: yup.string().when("visaissuance.thailand", {
      is: (thailand) => thailand,
      then: yup
        .string()
        .required("The latest arrival date in Thailand is required."),
      otherwise: yup.string(),
    }),
    stampEXP: yup.string().when("visaissuance.thailand", {
      is: (thailand) => thailand,
      then: yup.string().required("Permitted to stay in Thailand is required."),
      otherwise: yup.string(),
    }),
    workpermit: yup.object().shape({
      accommodationID: yup.string().when("visaissuance.thailand", {
        is: (thailand) => thailand,
        then: yup.string().required("Residence Type is required."),
        otherwise: yup.string(),
      }),
      houseNumber: yup.string().when("visaissuance.thailand", {
        is: (thailand) => thailand,
        then: yup.string().required("HouseNumber Type is required."),
        otherwise: yup.string(),
      }),
      soi: yup.string().when("visaissuance.thailand", {
        is: (thailand) => thailand,
        then: yup.string().required("Soi  is required."),
        otherwise: yup.string(),
      }),
      road: yup.string().when("visaissuance.thailand", {
        is: (thailand) => thailand,
        then: yup.string().required("Road  is required."),
        otherwise: yup.string(),
      }),
      addressInThailand: yup.string().when("visaissuance.thailand", {
        is: (thailand) => thailand,
        then: yup.string().required("Address  is required."),
        otherwise: yup.string(),
      }),
      ProvinceId: yup.string().when("visaissuance.thailand", {
        is: (thailand) => thailand,
        then: yup.string().required("Province  is required."),
        otherwise: yup.string(),
      }),
      DistrictId: yup.string().when("visaissuance.thailand", {
        is: (thailand) => thailand,
        then: yup.string().required("District  is required."),
        otherwise: yup.string(),
      }),
      SubDistrictId: yup.string().when("visaissuance.thailand", {
        is: (thailand) => thailand,
        then: yup.string().required("Sub-District  is required."),
        otherwise: yup.string(),
      }),
      Zipcode: yup.string().when("visaissuance.thailand", {
        is: (thailand) => thailand,
        then: yup.string().required("Zipcode  is required."),
        otherwise: yup.string(),
      }),
    }),
  });

  const vehicleConfigConfig = get(masterData, "vehicleConfig", []);
  const CountryConfig = get(masterData, "countryConfig", []);
  const VisaTypeConfig = get(masterData, "visaTypeConfig", []);
  const immPointConfig = get(masterData, "immPointConfig", []);

  const visaTypeConfig = get(masterData, "visaTypeConfig", []);
  const countryConfig = get(masterData, "countryEmbassy", []);
  const titleConfig = get(masterData, "titleConfig", []);
  const theImmigrationBureauConfig = get(
    masterData,
    "theImmigrationBureauConfig",
    []
  );

  const fetchStamp = async (params) => {
    const res = await HttpClient.get(
      `/api/stampfrom/responsesw/list?draftId=${draftId}&taskID=${params}`
    );
    setResponsesw(res);
  };

  const handleOnDownloadDocument = (event) => {
    setAnchorElDownloadDoc(event.currentTarget);
  };

  const handleCloseDownloadDocument = () => {
    setAnchorElDownloadDoc(null);
  };

  const handleOnUploadDocument = (event) => {
    setAnchorElUploadDoc(event.currentTarget);
  };

  const handleCloseUploadDocument = () => {
    setAnchorElUploadDoc(null);
  };

  const index = 0;

  return (
    <>
      <div style={{ display: "flex" }}>
        <TextField
          style={{ margin: 5 }}
          inputProps={{ readOnly: true }}
          variant="outlined"
          value={dataDetail?.smartNo}
          placeholder="No."
        />
        <TextField
          style={{ margin: 5 }}
          inputProps={{ readOnly: true }}
          variant="outlined"
          value={dataDetail?.smartserviceName}
          placeholder="Refer Name."
        />
      </div>

      <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <StyledTableCell colSpan={7}>
                <Typography variant="h6" className={classes.title}>
                  Personal Information
                </Typography>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <PersonalInfoSection formik={formik} disabled={disabled.PersonalInformation} />
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
        <Table className={classes.table}>
          <VisaIssuanceSection colSpan={7} formik={formik} disabled={disabled.VisaIssuance} />
        </Table>
      </TableContainer>

      {formik.values.visaissuance.thailand && (<TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <StyledTableCell colSpan={7}>
                <Typography
                  variant="h6"
                  className={classes.title}
                >
                  Address in Thailand
                </Typography>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <WorkPermit formik={formik} disabled={disabled.AddressInThailand} />
          </TableBody>
        </Table>
      </TableContainer>)}

      <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <StyledTableCell colSpan={7}>
                <Typography
                  variant="h6"
                  className={classes.title}
                >
                  Passport
                </Typography>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <PassportSection formik={formik} disabled={disabled.Passport} />
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <StyledTableCell colSpan={7}>
                <Typography
                  variant="h6"
                  className={classes.title}
                >
                  Latest travel information into Thailand
                </Typography>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TravelInfo formik={formik} disabled={disabled.LatestTravelnformation} />
          </TableBody>
        </Table>
      </TableContainer>

      {dataDetail?.workpermit?.isRequest && <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <StyledTableCell colSpan={4}>
                <Typography
                  variant="h6"
                  className={classes.title}
                >
                  No. of an alien (on work permit/ digital work permit)
                </Typography>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <StyledTableCell colSpan={4}>
                <div className={classes.cellContent}>
                  <div className={classes.wrapField}>
                    <InputLabel>
                      No. of an alien (14 Digits)
                    </InputLabel>
                    <TextField
                      disabled={disabled.DigitalWorkPermit || !canEdit}
                      variant="outlined"
                      className={classes.textField}
                      name={`workpermit.workPermitNo`}
                      value={get(
                        formik.values,
                        `workpermit.workPermitNo`,
                        ""
                      )}
                      error={isError(
                        `workpermit.workPermitNo`,
                        formik
                      )}
                      helperText={getErrorMessage(
                        `workpermit.workPermitNo`,
                        formik
                      )}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>
              </StyledTableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>}

      {dataDetail?.workpermit?.isRequest && <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <StyledTableCell colSpan={4}>
                <Typography
                  variant="h6"
                  className={classes.title}
                >
                  Company Information
                </Typography>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <CompanyInfoSection formik={formik} disabled={disabled.CompanyInformation} />
          </TableBody>
        </Table>
      </TableContainer>}

      {dataDetail?.workpermit?.isRequest && <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <StyledTableCell colSpan={4}>
                <Typography
                  variant="h6"
                  className={classes.tableTitle}
                >
                  Job Information
                </Typography>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <JobSection formik={formik} disabled={disabled.JobInformation} />
          </TableBody>
        </Table>
      </TableContainer>}

      <UploadDucument
        // setSaveDraft={setSaveDraft}
        handleSubmitForm={() => {
          formik.handleSubmit();
        }}
        isSubmitPreapprove
        handleSaveform={async () => {
          showAdminLoading();
          const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
          // console.log(smartFormFieldConfig);
          const documentFields = Object.keys(formik.values.document);

          const getFieldListConfig = defaultType.filter((field) =>
            documentFields.includes(field.smartName)
          );

          const getValue = (field) => {
            switch (field.smartName) {
              case "JobPositionWorkPermit": {
                const jobTable = get(
                  formik.values,
                  `document.${field.smartName}`,
                  []
                );
                const value = jobTable.filter((v) => !!v.jobTitle);

                return value || null;
              }
              default:
                return get(formik.values, `document.${field.smartName}`, null);
            }
          };

          const getSmartId = (field) =>
            get(detail, `${field.smartName}.smartId`, null);

          const params = {
            visaissuance: formik.values.visaissuance,
            draftId: draftId,
            workpermit: {
              visatypeId: formik.values.workpermit.visatypeId
                ? formik.values.workpermit.visatypeId
                : null,
              visaNo: formik.values.workpermit.visaNo,
              visaIssue: formik.values.workpermit.visaIssue,
              immNo: formik.values.workpermit.immNo,
              immPointID: formik.values.workpermit.immPointID
                ? formik.values.workpermit.immPointID
                : null,
              fromCountryID: formik.values.workpermit.fromCountryID
                ? formik.values.workpermit.fromCountryID
                : null,
              vehicleID: formik.values.workpermit.vehicleID
                ? formik.values.workpermit.vehicleID
                : null,
              thaiLastDate: formik.values.workpermit.thaiLastDate,
              stampEXP: formik.values.workpermit.stampEXP,
              accommodationID: formik.values.workpermit.accommodationID,
              houseNumber: formik.values.workpermit.houseNumber,
              soi: formik.values.workpermit.soi,
              road: formik.values.workpermit.road,
              addressInThailand: formik.values.workpermit.addressInThailand,
              provinceId: formik.values.workpermit.ProvinceId,
              districtId: formik.values.workpermit.DistrictId,
              subDistrictId: formik.values.workpermit.SubDistrictId,
              zipcode: formik.values.workpermit.Zipcode,
              isRequest: formik.values.workpermit?.isRequest,
              workPermitNo: formik.values.workpermit?.workPermitNo
            },
            detail: [
              ...(isGovernment
                ? getFieldListConfig.map((field) => ({
                  smartName: field.smartName,
                  smartId: getSmartId(field),
                  partfromId: field.partfromId,
                  configsmartId: field.configsmartId,
                  linkTable: field.linkTable,
                  // value: values[field.smartName] || null,
                  value: getValue(field),
                }))
                : []),
            ],
          };

          await dispatch(
            addPersonal({
              ...personalFieldResolver(formik.values.personal),
              visatypeID: null,
            })
          );

          try {
            const response = await HttpClient.post(
              `/api/visaform/smartfrom/add`,
              params
            );

            if (response.status) {
              hideAdminLoading();

              // alert("Success");
              // history.push(`/`);
              return response;
            }
            hideAdminLoading();
            return Promise.reject(response);
          } catch (error) {
            const newError = error;
            throw newError;
          }
        }}
        statusId={dataDetail?.statusProcessId}
        buttonRef={buttonRef}
      // handleClickBack={() =>
      //   dispatch(setSmartFormStep(LTR_STEP.SHOW_FORM_WORKPERMITSTEP))
      // }
      // conditionPrivate={detail?.IncomeMorethanHSPC?.value}
      />

      <Paper
        style={{ marginTop: 18, border: "2px solid #FE301B ", padding: 56, paddingTop: 0 }}
      >

        <div style={{ display: "flex", justifyContent: "center", margin: 18, marginBottom: 46, gap: 18 }}>
          <Button
            variant="contained"
            onClick={handleOnDownloadDocument}
            color="primary"
          >
            <CloudDownload style={{ marginRight: 8 }} />
            Download document
          </Button>
          <Button
            variant="contained"
            onClick={handleOnUploadDocument}
            color="primary"
          >
            <CloudUpload style={{ marginRight: 8 }} />
            Upload document
          </Button>
          <Menu
            id="basic-menuDownloadDocument"
            anchorEl={anchorElDownloadDoc}
            open={openDownloadDocMenu}
            onClose={handleCloseDownloadDocument}
            MenuListProps={{
              "aria-labelledby": "basic-buttonDownloadDocument",
            }}
          >
            {downloadDocumentList.map((button) => (
              <MenuItem
                key={button.logBookID}
                onClick={async () => {

                  setAnchorElDownloadDoc(null);

                  const filename = button.filename + button.ext
                  const blob = await FileService.getFile(button.fileID);
                  const blobFile = new File([blob], filename, { type: mime.getType(button.ext) });

                  window.open(URL.createObjectURL(blobFile), "_blank");

                }}>
                {button.buttonName}
              </MenuItem>
            ))}
          </Menu>
          <Menu
            id="basic-menuUploadDocument"
            anchorEl={anchorElUploadDoc}
            open={openUploadDocMenu}
            onClose={handleCloseUploadDocument}
            MenuListProps={{
              "aria-labelledby": "basic-buttonUploadDocument",
            }}
          >
            {downloadDocumentList.map((button) => (
              <MenuItem
                key={button.logBookID}
                onClick={async () => {
                  setSelectedUploadDocId(button.logBookID)
                  setAnchorElUploadDoc(null)
                  uploadFileInputRef.current?.click()
                }}
              >
                {button.buttonName}
              </MenuItem>
            ))}
          </Menu>
          <input
            ref={uploadFileInputRef}
            accept="application/pdf"
            style={{ display: "none" }}
            id="upload-file-from-buttons"
            type="file"
            onClick={(event) => { event.target.value = null }}
            onChange={async (event) => {

              if (selectedUploadDocId && event.target.files[0]) {
                showAdminLoading()

                try {
                  await FileService.uploadFileDoc({
                    file: event.target.files[0],
                    FileID: null,
                    Status: true,
                    logBookID: selectedUploadDocId
                  })

                  if (dataDetail?.draftId) {
                    getDownloadDocumentList(dataDetail?.draftId);
                  }
                  hideAdminLoading()
                } catch (error) {
                  hideAdminLoading()
                }

              }
            }}
          />
        </div>

        {dataDetail?.workpermit?.isRequest && (
          <FormGroup style={{ padding: 10, gap: 24 }} row>
            {/* <div className={classes.wrapField} style={{ marginRight: 5 }}>
              <DatePicker
                inputVariant="outlined"
                openTo="year"
                format="DD-MM-YYYY"
                label="Workpermit Start Date"
                views={["year", "month", "date"]}
                name="startDate"
                value={formik.values.startDate || null}
                onChange={(date) => {
                  formik.setFieldValue(`startDate`, date.format("YYYY-MM-DD"));
                }}
                error={isError(`startDate`, formik)}
                helperText={getErrorMessage(`startDate`, formik)}
              />
            </div> */}

            <div className={classes.wrapField}>
              <DatePicker
                inputVariant="outlined"
                disablePast
                disableFuture={false}
                openTo="year"
                format="DD-MM-YYYY"
                label="Workpermit Date"
                views={["year", "month", "date"]}
                name="endDate"
                // value={formik.values.workpermit.stampEXP || null}
                value={get(formik.values, `endDate`, null) || null}
                onChange={(date) => {
                  formik.setFieldValue(`endDate`, date.format("YYYY-MM-DD"));
                }}
                error={isError(`endDate`, formik)}
                helperText={getErrorMessage(`endDate`, formik)}
              />
            </div>
          </FormGroup>
        )}
        {((dataDetail?.staffID === profile?.userID) || (profile?.roleId === RoleId.Admin)) && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {(dataDetail?.statusProcessId === "RVW" ||
              dataDetail?.statusProcessId === "RPA") && (
                <Button
                  variant="outlined"
                  onClick={() => {
                    formik.handleSubmit();
                    buttonRef.current.click();
                  }}
                  style={{ width: 150 }}
                  color="primary"
                >
                  Approve
                </Button>
              )}
            {dataDetail?.statausID !== "RVW" ? (
              <>
                <Button
                  id="basic-buttonPrint"
                  aria-controls={openPrint ? "basic-menuPrint" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openPrint ? "true" : undefined}
                  onClick={handleClickPrint}
                  variant="outlined"
                  color="primary"
                  style={{ marginLeft: 10, width: 150, height: 50 }}
                >
                  Print
                </Button>
                <Menu
                  id="basic-menuPrint"
                  anchorEl={anchorElPrint}
                  open={openPrint}
                  onClose={handleClosePrint}
                  MenuListProps={{
                    "aria-labelledby": "basic-buttonPrint",
                  }}
                >
                  <MenuItem
                    key={index}
                    onClick={async () => {
                      const filename = draftId + ".pdf";
                      const blob = await AllDocumentsService.downloadDocDetail(
                        draftId
                      );
                      const blobFile = new File([blob], filename, {
                        type: mime.getType(".pdf"),
                      });

                      window.open(URL.createObjectURL(blobFile), "_blank");

                      setAnchorElPrint(null);
                    }}
                  >
                    Qualification endorsement
                  </MenuItem>
                  <MenuItem
                    key={index}
                    onClick={async () => {
                      const filename = draftId + ".pdf";
                      const blob =
                        await AllDocumentsService.downloadLongResidentVisaTH(
                          draftId
                        );
                      const blobFile = new File([blob], filename, {
                        type: mime.getType(".pdf"),
                      });

                      window.open(URL.createObjectURL(blobFile), "_blank");

                      setAnchorElPrint(null);
                    }}
                  >
                    Report to Immigration Bureau
                  </MenuItem>
                  {dataDetail?.workpermit?.isRequest && (
                    <MenuItem
                      key={index}
                      onClick={async () => {
                        const filename = draftId + ".pdf";
                        const blob =
                          await AllDocumentsService.downloadNotificationPassLongVisaDWPTH(
                            draftId
                          );
                        const blobFile = new File([blob], filename, {
                          type: mime.getType(".pdf"),
                        });

                        window.open(URL.createObjectURL(blobFile), "_blank");

                        setAnchorElPrint(null);
                      }}
                    >
                      Report to Department of Employment
                    </MenuItem>
                  )}
                </Menu>
              </>
            ) : null}
          </div>
        )}

        {error_msg !== "" && <Typography>SW MSG : {error_msg}</Typography>}
        <Divider style={{ margin: 5, marginTop: 18 }} />
        {responsesw?.results !== null && (
          <Typography>
            SW MSG : {responsesw?.results?.response_message}
          </Typography>
        )}

        {listPreapprove?.results !== null &&
          listPreapprove?.results !== undefined && (
            <>
              <Typography>
                {listPreapprove?.results?.pre_approve_by} MSG :{" "}
                {listPreapprove?.results?.remark}
              </Typography>
              <Typography variant="body2" style={{ color: "#979AAA" }}>
                Date :{" "}
                {moment(listPreapprove?.results?.pre_approve_date).format(
                  "YYYY/MM/DD HH:MM"
                )}
              </Typography>
            </>
          )}
      </Paper>
    </>
  );
}
